import { render, staticRenderFns } from "./AssignBaseline.vue?vue&type=template&id=437d533b"
import script from "./AssignBaseline.vue?vue&type=script&lang=js"
export * from "./AssignBaseline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports